import { render, staticRenderFns } from "./GeneralDataTab.vue?vue&type=template&id=42f6ad54&scoped=true&"
import script from "./GeneralDataTab.vue?vue&type=script&lang=js&"
export * from "./GeneralDataTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f6ad54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VDataTable,VSimpleCheckbox})
